import React, { useContext, useEffect } from "react";
import Layout from "antd/es/layout";
import { useNavigate } from "react-router-dom";
import { GlobalStoreContext } from "@/context";
import LeftContent from "./LeftContent";
import ManagerCreator from "./ManagerCreator";
import UserCreator from "./UserCreator";
import UserManager from "./UserManager";
import ModuleManager from "./ModuleManager";
import Navigator from "./Navigator";
import AdvertConfig from "./AdvertConfig";
import { getAdmin } from "@/server/adminManager";

const { Header, Sider, Content } = Layout;

export default function MainPage() {
  const { setIsLogin, currentTab } = useContext(GlobalStoreContext);
  const navigate = useNavigate();
  useEffect(() => {
    const userId = localStorage.getItem("tgb_admin_id");
    const acc = localStorage.getItem("tgb_admin_account");
    const pas = localStorage.getItem("tgb_admin_password");
    if (userId && acc && pas) {
      // 执行获取用户信息操作
      getAdmin({
        account: acc,
        password: pas,
      }).then((res) => {
        if (!res) {
          setIsLogin(false);
          navigate("/");
        }
      });
    }
  }, []);
  return (
    <Layout
      style={{
        height: "100vh",
      }}
    >
      <Header
        style={{
          backgroundColor: "#7dbcea",
          height: 48,
          padding: 0,
        }}
      >
        <Navigator />
      </Header>
      <Layout hasSider style={{ flex: 1, position: "relative" }}>
        <Sider width="208">
          <LeftContent />
        </Sider>
        <Content
          style={{
            backgroundColor: "#108ee9",
          }}
        >
          {currentTab === 0 && <ManagerCreator />}
          {currentTab === 1 && <UserCreator />}
          {currentTab === 2 && <UserManager />}
          {currentTab === 3 && <ModuleManager />}
          {currentTab === 4 && <AdvertConfig />}
        </Content>
      </Layout>
    </Layout>
  );
}
